import React from "react";
import { Mail, Instagram } from "lucide-react";
import { SITE } from "@/config/site";
import { LogoFull } from "./Logo";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-[rgba(198,162,99,0.14)]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <LogoFull className="h-20 w-[320px] logo-glow" />
            <p className="mt-5 max-w-md text-sm text-[rgb(var(--bone-dim))] leading-relaxed">
              Strategic content, brand direction, and digital media for
              businesses, brands, teams, and creators.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-[0.3em] uppercase text-[rgb(var(--bone-dim))]">
              Contact
            </div>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <a
                  href={`mailto:${SITE.email}`}
                  className="inline-flex items-center gap-2 text-[rgb(var(--bone))] hover:text-[rgb(var(--gold-soft))] transition-colors"
                >
                  <Mail size={14} /> {SITE.email}
                </a>
              </li>
              <li>
                <a
                  href={SITE.instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-[rgb(var(--bone))] hover:text-[rgb(var(--gold-soft))] transition-colors"
                >
                  <Instagram size={14} /> @{SITE.instagram}
                </a>
              </li>
              <li className="text-[rgb(var(--bone-dim))]">{SITE.location}</li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-[0.3em] uppercase text-[rgb(var(--bone-dim))]">
              Navigate
            </div>
            <ul className="mt-4 space-y-3 text-sm">
              <li><a href="#top" className="text-[rgb(var(--bone))] hover:text-[rgb(var(--gold-soft))]">Home</a></li>
              <li><a href="#services" className="text-[rgb(var(--bone))] hover:text-[rgb(var(--gold-soft))]">Services</a></li>
              <li><a href="https://instagram.com/UbertiCreative" target="_blank" rel="noopener noreferrer" className="text-[rgb(var(--bone))] hover:text-[rgb(var(--gold-soft))]">Instagram</a></li>
              <li><a href="#contact" className="text-[rgb(var(--bone))] hover:text-[rgb(var(--gold-soft))]">Contact</a></li>
            </ul>
          </div>
        </div>

        <div className="hairline my-10" />

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-[rgb(var(--bone-dim))]">
          <div>© {year} Uberti Creative. All rights reserved.</div>
          <div className="tracking-[0.22em] uppercase">
            Strategic content & digital media · Vaughan / GTA
          </div>
        </div>
      </div>
    </footer>
  );
}
